import { c as _c } from "react/compiler-runtime";
import { ContentContainer, Layout } from '@/components/layout';
import { type IntlProps, getIntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import fs from 'fs/promises';
import { join } from 'path';
import { serialize } from 'next-mdx-remote/serialize';
import { SeoHeader } from '@/components/SeoHeader';
import { Headline, Text } from '@/components/typography';
import { Link } from '@/components/links';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  post: MDXRemoteSerializeResult;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(props) {
  const $ = _c(11);
  const {
    post,
    menuPromoBanners
  } = props;
  const t0 = post.frontmatter.title as string | null || "";
  const t1 = post.frontmatter.nofollow as boolean || false;
  const t2 = post.frontmatter.noindex as boolean || false;
  let t3;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2) {
    t3 = <SeoHeader title={t0} nofollow={t1} noindex={t2} />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      h1: _temp,
      h2: _temp2,
      h3: _temp3,
      h4: _temp4,
      h5: _temp5,
      h6: _temp6,
      p: _temp7,
      b: _temp8,
      ul: _temp9,
      a: _temp10
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== post) {
    t5 = <ContentContainer className="px-2 pt-20 pb-8 lg:pt-32"><div suppressHydrationWarning={true}><MDXRemote {...post} components={t4} /></div></ContentContainer>;
    $[5] = post;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== menuPromoBanners || $[8] !== t3 || $[9] !== t5) {
    t6 = <Layout menuPromoBanners={menuPromoBanners}>{t3}{t5}</Layout>;
    $[7] = menuPromoBanners;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp10(element_8) {
  return <Text className="inline"><Link analyticsParam="postLink" testId="postLink" to={element_8.href || ""}>{element_8.children}</Link></Text>;
}
function _temp9(element_7) {
  return <ul suppressHydrationWarning={true} className="mb-2 list-disc space-y-3 pl-5 marker:text-blue-500 md:mb-4">{element_7.children}</ul>;
}
function _temp8(element_6) {
  return <Text weight="semibold" {...element_6} />;
}
function _temp7(element_5) {
  return <Text className="mb-2" {...element_5} />;
}
function _temp6(element_4) {
  return <Headline className="mb-2" as="h6" {...element_4} />;
}
function _temp5(element_3) {
  return <Headline className="mb-2" as="h6" {...element_3} />;
}
function _temp4(element_2) {
  return <Headline className="mb-2" as="h6" {...element_2} />;
}
function _temp3(element_1) {
  return <Headline className="mb-2" as="h5" {...element_1} />;
}
function _temp2(element_0) {
  return <Headline className="mb-2" as="h4" {...element_0} />;
}
function _temp(t0) {
  const {
    id,
    ...element
  } = t0;
  return <Headline className="mb-2" variant="h3" as="h1" id={id || "title"} {...element} />;
}
export const getStaticPaths = async () => {
  const postsDir = join(process.cwd(), 'public', 'dokumenty', 'posts', 'cs');
  const posts = await fs.readdir(postsDir);
  const paths = posts.map(post => ({
    params: {
      post: post.replace(/\.md$/, '')
    }
  }));
  return {
    paths: paths?.filter(Boolean) || [],
    fallback: false
  };
};
export const getStaticProps = (async ctx => {
  const postSlug = ctx.params?.post as string;
  if (!postSlug) throw new Error('No post slug');
  const postPath = join(process.cwd(), 'public', 'dokumenty', 'posts', 'cs',
  // TODO: Add more languages
  `${postSlug}.md`);
  const postData = await fs.readFile(postPath, 'utf-8');
  const post = await serialize(postData, {
    parseFrontmatter: true
  });
  return {
    props: {
      post,
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, []))
    }
  };
}) satisfies GetStaticProps<Props>;